import {
  ControlItem,
  ControlLabel,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'
import styled from 'styled-components'

const CoordinateDisplay = styled.span`
  font-family: monospace;
  font-size: 12px;
  line-height: 18px;
  color: #aaa;
  text-align: right;
`

export const DebugDataDisplay = ({
  cameraPosition,
  lookingAtPosition,
}: {
  cameraPosition: string
  lookingAtPosition: string
}) => {
  return (
    <>
      <ControlItem>
        <ControlLabel>Camera Position</ControlLabel>
        <CoordinateDisplay>{cameraPosition || 'N/A'}</CoordinateDisplay>
      </ControlItem>
      <ControlItem>
        <ControlLabel>Looking At</ControlLabel>
        <CoordinateDisplay>{lookingAtPosition || 'N/A'}</CoordinateDisplay>
      </ControlItem>
    </>
  )
}
